import { twMerge } from "tailwind-merge"

const BodyDefault: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return (
    <p
      className={twMerge("text-[1rem] md:text-[1.125rem] font-bold leading-1.5 my-[1.25rem] md:my-[1.5rem]", className)}
      {...props}
    />
  )
}

export default BodyDefault
